import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { setHeading } from "../../redux/slice/headerSlice";
import { useDispatch } from "react-redux";
import Banner from "../common/Banner";
import { transaction } from "../auth/auth";
import Loader from "../partial/Loader";
import swal from "sweetalert";
import Header from "../layout/Header";

const ClaimNow = () => {
  const navigate = useNavigate()
  const [loader, setLoader] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const tiers = localStorage.getItem("customerTier");
  const tierPoints = {
    Silver: "20K",
    Gold: "30K",
    Platinum: "50K",
    "Founder Club": "80K",
  };
  const points = tierPoints[tiers];

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setHeading("Claim Now"));
  }, []);

  const submit = async () => {
    setLoader(true);
    const token = JSON.parse(localStorage.getItem("token_gen"));
    const body = {
      activitytype: "Welcome Bonus",
      companyid: localStorage.getItem("customerid"),
      schemacode: "TSC010043",
    };
    const transRes = await transaction(token.access_token, body);
    if (transRes.message === "Request processed successfully.") {
      setLoader(false);
      setShowPopup(true);
    } else {
      swal({
        position: "center",
        icon: "error",
        title: transRes?.message,
        showConfirmButton: false,
        timer: 5000,
      });
      setLoader(false);
    }
  };
  const goToPreviousTab = () => {
    navigate(-1);
  };
  return (
    <>
      <Header goToPreviousTab={goToPreviousTab} isHomePage={false} />
      <main>
        {loader && <Loader />}
        <Banner tiers={tiers} />
        <section>
          <div className="tnc-box">
            <div className="tnc-box-inner">
              <div className="tnc-box-inner-heading">
                <h4>Terms & Conditions</h4>
              </div>
              <div className="tnc-box-inner-list">
                <ul>
                  <li data-index="1">
                    This welcome offer is valid for one-time use per user only
                  </li>
                  {/* <li data-index="2">
                    The offer must be claimed within the offer period (July 1 to
                    July 31st)
                  </li> */}
                </ul>
              </div>
            </div>
            <div className="tnc-box-inner">
              <div className="tnc-box-inner-heading">
                <h4>How to Claim</h4>
              </div>
              <div className="tnc-box-inner-list">
                <ul>
                  <li data-index="1">Click on Claim Now</li>
                  <li data-index="2">
                    Upon successful claiming, {points.toLocaleString()} points will be credited to your
                    wallet
                  </li>

                </ul>
              </div>
            </div>
            <Link
              to=""
              className="btn btn-gold btn-block"
              id="claim-now"
              onClick={submit}
            >
              Claim Now
            </Link>
          </div>
        </section>
        {showPopup && (
          // <div className="popup show" id="congratulationspopup">
          //   <div className="popup-box">
          //     <Link
          //       to=""
          //       className="close-popup"
          //       onClick={() => setShowPopup(false)} // Close popup on click
          //     >
          //       X
          //     </Link>
          //     <div className="popup-box-inner">
          //       <h4>Congratulations!</h4>
          //       <p>{points.toLocaleString()} points successfully added to your wallet</p>
          //       <Link to="/home" className="btn btn-block">
          //         Back to Home
          //       </Link>
          //     </div>
          //   </div>
          // </div>

          <div className="popup show" id="congratulationspopup">
            <div className="popup-box">
              <Link
                href="javascript:void(0)"
                className="close-popup"
                id="closecongratulationspopup"
                onClick={() => setShowPopup(false)}
              >
                X
              </Link>
              <div className="popup-box-congratulations">
                <span>
                  <img src="images/confetti.png" alt="Confetti" />
                </span>
                <h4>Congratulations!</h4>
                <p>{points.toLocaleString()} points successfully added to your wallet</p>
                <Link to="/home" className="btn btn-block">
                  Back to Home
                </Link>
              </div>
            </div>
          </div>
        )}
      </main>
    </>
  );
};

export default ClaimNow;
